export default "__VITE_PUBLIC_ASSET__2cfc993c__"